
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collections-and-research/archive-and-research-area/[slug]/[caseStudyId]",
      function () {
        return require("private-next-pages/collections-and-research/archive-and-research-area/[slug]/[caseStudyId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collections-and-research/archive-and-research-area/[slug]/[caseStudyId]"])
      });
    }
  